import * as signalR from "@microsoft/signalr";

export default function BodyTemperatureHub(props: {
  sn?: string;
  setBodyTemperatureData?: Function;
}) {
  const { sn, setBodyTemperatureData } = props;

  if (!sn) {
    console.error("BodyTemperatureHub: Serial number (sn) is required");
    return () => {};
  }

  let connection = new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_BASE_URL}bodyTemperatureHub`)
    .build();

  connection
    .start()
    .then(() => {
      console.log("Started BodyTemperatureHub for sn:", sn);
      connection.invoke("SubscribeToBodyTemperatureData", sn);
    })
    .catch((err: any) => {
      console.error(`BodyTemperatureHub error for sn ${sn}:`, err.toString());
    });

  connection.on("ReceiveSensorData", (data: any) => {
    console.log(
      "Raw body temperature data received for sn:",
      sn,
      "data:",
      data
    );
    console.log("Body temperature Data type:", typeof data);
    const formattedData =
      typeof data === "number" ? { sn, value: data } : { sn, ...data };
    setBodyTemperatureData && setBodyTemperatureData([formattedData]);
  });

  return () => {
    console.log("Stopping BodyTemperatureHub connection for sn:", sn);
    connection.stop();
  };
}
